import { render, staticRenderFns } from "./WorkforceProductType.vue?vue&type=template&id=06bdcbec&"
import script from "./WorkforceProductType.vue?vue&type=script&lang=js&"
export * from "./WorkforceProductType.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceProductType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports